import "./PureDetailBooking.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import BookYourCleanToday from "./sections/BookYourCleanToday";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function PureDetailBookingPage() {
  return <div>
      <PureDetailHeader />
      <BookYourCleanToday />
      <PureDetailFooter />
    </div>;
}